import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/index/index.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history', // 使用 history 模式，路径更干净。默认是 hash（#）
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home
    },
    // 在路由配置中
{
  path: '/index/PaymentSuccess',
  name: 'PaymentSuccess',
  component: () => import('@/views/index/PaymentSuccess.vue')
}
  ]
})

export default router